<div class="icon-container">
  <mat-icon class="icon" svgIcon="icon_x"></mat-icon>
</div>
